import { FC, useEffect, Dispatch, SetStateAction } from "react";
import { Checkbox } from "src/atoms/Checkbox";

interface Props {
  shouldAddToCollection: boolean;
  setShouldAddToCollection: Dispatch<SetStateAction<boolean>>;
}

const AddToCollectionCheckbox: FC<Props> = ({
  shouldAddToCollection,
  setShouldAddToCollection,
}) => {
  useEffect(() => {
    const shouldAddToCollectionFromLocalStorage = localStorage.getItem(
      "shouldAddToCollection"
    );
    if (shouldAddToCollectionFromLocalStorage) {
      setShouldAddToCollection(
        shouldAddToCollectionFromLocalStorage === "true"
      );
    }
  }, [setShouldAddToCollection]);

  const toggleAddToCollection = () => {
    setShouldAddToCollection((prevShouldAddToCollection: boolean) => {
      window.localStorage.setItem(
        "shouldAddToCollection",
        JSON.stringify(!prevShouldAddToCollection)
      );
      return !prevShouldAddToCollection;
    });
  };

  return (
    <Checkbox checked={shouldAddToCollection} onChange={toggleAddToCollection}>
      Add to Collection
    </Checkbox>
  );
};

export default AddToCollectionCheckbox;
